// localStorage 工具

const KEY_COMPLETED = 'puzzle_completed_levels';
const KEY_LAST_PLAYED = 'puzzle_last_played_level';

export function getCompletedLevels(): number[] {
  try {
    const raw = localStorage.getItem(KEY_COMPLETED);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (Array.isArray(arr)) return arr.filter(n => typeof n === 'number');
    return [];
  } catch {
    return [];
  }
}

export function addCompletedLevel(levelNumber: number): void {
  const levels = getCompletedLevels();
  if (!levels.includes(levelNumber)) {
    levels.push(levelNumber);
    levels.sort((a, b) => a - b);
    localStorage.setItem(KEY_COMPLETED, JSON.stringify(levels));
  }
}

export function isLevelUnlocked(levelNumber: number): boolean {
  if (levelNumber === 1) return true;
  const levels = getCompletedLevels();
  return levels.includes(levelNumber - 1);
}

export function getLastPlayedLevel(): number {
  try {
    const raw = localStorage.getItem(KEY_LAST_PLAYED);
    const n = raw ? parseInt(raw, 10) : NaN;
    if (Number.isFinite(n) && n >= 1) return n;
  } catch {}
  return 1;
}

export function setLastPlayedLevel(levelNumber: number): void {
  try {
    localStorage.setItem(KEY_LAST_PLAYED, String(levelNumber));
  } catch {}
}
